import './hero.component.scss'

const heroEl = document.querySelector('.hero')

if (heroEl) {
  const heroImgWrapEl = heroEl.querySelector('.hero__img')

  if (heroImgWrapEl) {
    const maskUrl = heroImgWrapEl.dataset.mask
    delete heroImgWrapEl.dataset.mask
    
    heroImgWrapEl.style.maskImage = `url(${maskUrl})`
    heroImgWrapEl.style.webkitMaskImage = `url(${maskUrl})`
  }
}